import React from 'react';
import {getPictoGroupingSvgD} from '@core_x6/lib/draw/PathMap';
import PathIcon from './PathIcon';
import {Property} from 'csstype';

interface IEntry {
	type: string;
	typeName: string;
	shape: string;
	width: number;
	height: number;
	iconRef: string | null;
}

interface IColors {
	fillColor: Property.Color;
	lineColor: Property.Color;
}

interface IModeler {
	getIconColorsForType: (type: string) => IColors;
	getIconSvgPath: (iconRef: string | null, width?: number, height?: number) => string | null;
}

interface IEntryIconProps {
	entry: IEntry;
	modeler: IModeler | null;
}

/** Мини-иконка элемента (тот же path и цвет слоя, что в углу узла на канве). */
const EntryIcon: React.FC<IEntryIconProps> = ({entry, modeler}) => {
	const size = 24;
	const colors = modeler?.getIconColorsForType?.(entry.type) ?? {
		fillColor: '#fff',
		lineColor: '#000',
	};

	const svgStyle = {flexShrink: 0, display: 'block', margin: 'auto'};

	if (entry.shape === 'junction') {
		return (
			<svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={svgStyle}>
				<circle
					cx={size / 2}
					cy={size / 2}
					r={size / 2 - 2}
					fill={colors.fillColor}
					stroke={colors.lineColor}
					strokeWidth={1}
				/>
			</svg>
		);
	}
	if (entry.shape === 'group') {
		const path =
			modeler?.getIconSvgPath?.('PICTO_GROUPING', size, size) ??
			getPictoGroupingSvgD(size, size);
		return <PathIcon path={path} size={size} colors={colors} svgStyle={svgStyle} />;
	}
	if (entry.shape === 'sticker') {
		const pad = 4;
		return (
			<svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={svgStyle}>
				<rect
					x={pad + 1}
					y={pad + 1.5}
					width={size - pad * 2}
					height={size - pad * 2}
					rx={2}
					ry={2}
					fill="rgba(0,0,0,0.16)"
					stroke="none"
				/>
				<rect
					x={pad}
					y={pad}
					width={size - pad * 2}
					height={size - pad * 2}
					rx={2}
					ry={2}
					fill={colors.fillColor === 'none' ? '#FFF9B1' : colors.fillColor}
					stroke="none"
				/>
			</svg>
		);
	}

	const path = modeler?.getIconSvgPath?.(entry.iconRef, size, size);

	if (path) {
		return <PathIcon path={path} size={size} colors={colors} svgStyle={svgStyle} />;
	}

	return (
		<span
			style={{
				width: size,
				height: size,
				fontSize: 10,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexShrink: 0,
				margin: 'auto',
				color: colors.lineColor,
			}}
		>
			{entry.typeName?.charAt(0) ?? '?'}
		</span>
	);
};

export default EntryIcon;
